import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

import { ArticlesTable } from '~/components/settings/admin/articleMaster/ArticlesTable';

import { validateSearch } from './-routeParams';

export const Route = createFileRoute(
  '/(main)/settings/article-master/articles/',
)({
  component: ArticlesTable,
  validateSearch,
});

export const ARTICLE_MASTER_ARTICLES = buildRouteExport({
  Route,
});
